import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  TURNOFF_LOADER,
} from "../../constants/auth";

export const loginSuccess = (data) => ({ type: LOGIN_SUCCESS, data });

const logoutSuccess = () => ({ type: LOGOUT_SUCCESS });

export const actionTurnOffWelecomeScreen = () => ({
  type: TURNOFF_LOADER,
});

export const actionLogout = () => async (dispatch) => {
  dispatch(logoutSuccess());
};
